<template>
  <div v-if="isMenu" class="sidebar">
    <!-- <el-scrollbar wrap-class="scrollbar-wrapper" style="margin-right: 0; height: inherit"> -->
    <el-menu :collapse="collapse" :unique-opened="true" :collapse-transition="true" router
      class="el-menu-vertical-demo leftnav2Menu" :default-active="this.$route.meta.index" mode="vertical"
      :default-openeds="open_list" @select="handleSelect" background-color="#1b4283">
      <!-- <div class="logobox">
          <img class="logoimg" :src="logoImage" />
        </div> -->
      <!-- 10008的logo -->
      <div class="logobox">
        <img class="logoimg" :src="logoImage" />
        <!-- // 给金威单独定制首页 -->
        <!-- <span>称重查询端</span> -->
      </div>
      <template v-for="(item, key) in allmenu">
        <template v-if="item.children">
          <el-submenu :index="'/' + item.urlst" :key="item.rescid" v-show="rankList[key] == item.rescid">
            <template slot="title">
              <i :class="item.icon"></i>
              <span slot="title">{{ item.namest }} </span>
            </template>

            <template v-for="subItem in item.children" :index="subItem.rescid">
              <el-menu-item-group :key="subItem.rescid" v-if="!subItem.children" class="name">

                <el-menu-item :index="'/' + subItem.urlst">
                  <i :class="subItem.icon"></i>
                  {{ subItem.namest }}
                </el-menu-item>
              </el-menu-item-group>

              <el-submenu :index="'/' + subItem.urlst" v-else>
                <i :class="subItem.icon"></i>
                <span slot="title">{{ subItem.namest }}</span>
                <el-menu-item v-for="subItems in subItem.children" :key="subItems.rescid"
                  :index="'/' + subItems.urlst">{{ subItems.namest }}</el-menu-item>
              </el-submenu>
            </template>
          </el-submenu>
        </template>
        <template v-else>
          <el-menu-item :index="'/' + item.urlst" :key="item.rescid">
            <i :class="item.icon"></i>
            <span slot="title">{{ item.namest }}</span>
          </el-menu-item>
        </template>
      </template>
    </el-menu>
    <!-- </el-scrollbar> -->
  </div>
</template>
<script>
// import { getSession, getUserMenus } from "../api/userMG";
import NavMenu from "./NavMenu.vue";
import { mapGetters } from "vuex";
export default {
  name: "leftnav",
  components: {
    NavMenu: NavMenu,
  },
  data() {
    return {
      allmenu: [],
      isMenu: true,
      logoImage: "",
      open_list: [],
      rankList: [],
    };
  },
  created() {

  },
  mounted() {
    let that = this;
    let rank = that.$store.state.loginData[0];
    if (rank == undefined) {
      that.$message({
        type: "info",
        message: "登录错误,请重新登录",
      });
      that.$router.push({
        path: "/",
      });
    } else {
      if (rank.rank == "000") {
        that.rankList = [101, 102, 103, 104];
      } else {
        that.rankList = rank.rank.split(",");
      }
    }


    this.allmenu = [
      {
        rescid: "101",
        // urlst: "weightSearch/weightOperate",
        urlst: "cloudWeight/webWeight",


        icon: "el-icon-s-order",
        namest: "称重业务",
        children: [
          {
            rescid: "1-1",
            // urlst: "weightSearch/weightOperate",
            urlst: "cloudWeight/webWeight",

            icon: "el-icon-coin",
            namest: "称重操作",
          },

        ],
      },
      {
        rescid: "102",
        urlst: "count/search",
        icon: "el-icon-s-order",
        namest: "统计查询",
        children: [
          {
            rescid: "2-1",
            urlst: "count/search",
            icon: "el-icon-coin",
            namest: "数据查询",
          },
          {
            rescid: "2-2",
            urlst: "count/statistics",
            icon: "el-icon-coin",
            namest: "数据统计",
          },

        ],

      },
      // {
      //   rescid: "3",  
      //   urlst: "users/userList",  
      //   children: [],  
      //   icon: "el-icon-s-order",  
      //   namest: "系统管理",  
      // },
      {
        rescid: "103",
        urlst: "system/setUp",
        icon: "el-icon-s-order",
        namest: "系统管理",
        children: [

          {
            rescid: "4-0",
            urlst: "system/setUp",
            icon: "el-icon-bank-card",
            namest: "系统设置",
          },

          {
            rescid: "4-1",
            urlst: "system/unitManage",
            icon: "el-icon-bank-card",
            namest: "单位管理",
          },

          {
            rescid: "4-2",
            urlst: "system/goodsManage",
            icon: "el-icon-bank-card",
            namest: "品名管理",
          },
          {
            rescid: "4-3",
            urlst: "system/spec",
            icon: "el-icon-bank-card",
            namest: "规格管理",
          },

          {
            rescid: "4-4",
            urlst: "system/carManage",
            icon: "el-icon-bank-card",
            namest: "车辆信息",
          },

          // {
          //   rescid: "4-2",  
          //   urlst: "manage/userManage",  
          //   icon: "el-icon-bank-card",  
          //   namest: "用户信息",  
          // },

          // {
          //   rescid: "4-8",  
          //   urlst: "manage/systemSetting",  
          //   icon: "el-icon-bank-card",  
          //   namest: "系统设置",  
          // },


        ],

      },
      {
        rescid: "104",
        urlst: "cloudWeight/userManager",
        icon: "el-icon-s-order",
        namest: "用户设置",
        children: [
          {
            rescid: "5-1",
            urlst: "cloudWeight/userManager",
            icon: "el-icon-bank-card",
            namest: "用户管理",
          },
        ],
      },
    ];


  },

  computed: {
    ...mapGetters(["sidebar"]),
    collapse() {

      if (this.sidebar.opened) {
        // this.logoImage = require("../assets/img/logoSmall.png");
      } else {
        this.logoImage = require("../assets/img/logoKu.png");
        // this.logoImage = require("../assets/img/logo10008.png");
      }
      return this.sidebar.opened;
    },
  },
  methods: {
    // 切换菜单列表
    handleSelect(index) {
      this.$nextTick(() => {
        var currentTag = document.getElementsByClassName("name")[6];
        var childElement = currentTag ? currentTag.querySelector('li') : null;
        // childElement.classList.add("customizedCss");
      });
      this.changeMenuId(index);
    },
    // 转换路由到id
    changeMenuId(urlst) {
      this.allmenu.map((item) => {
        if (item.children) {
          item.children.map((index) => {
            if ("/" + index.urlst == urlst) {
              // this.$bus.emit("menuId", index.rescid);
              this.$store.commit("getMenuId", index.rescid);
            }
          });
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
  text-align: left;
}

.el-menu-item-group__title {
  padding: 0px;
}

.leftnav2Menu {
  border: none;
  background-color: transparent;
}

.logobox {
  height: 70px;
  line-height: 40px;
  color: #9d9d9d;
  font-size: 20px;
  text-align: center;
  padding: 0;
  width: 100%;
  margin: 10px auto;

  // 给金威单独定制首页 -->
  // span {
  //   color: white;
  //   float: left;
  //   display: inline-block;
  //   margin: 15px 4px;
  // }

  // img {
  //   width: 40%;
  //   float: left;
  // }
}

.el-menu-item.is-active {
  color: #354052;
  background: #f5f5f5 !important;
}

.scrollbar-wrapper {
  margin-right: 0 !important;
  overflow: auto;
}

/deep/ .el-menu-item-group__title {
  padding: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/leftnav2.vue